import React from "react";
import styles from "./DashboardStudent.module.sass";
import Product from "./Products";


const DashboardStudent = () => {
  return (
    <>
      <div className={styles.shop}>
        <div className={styles.background}>
          <img src="/images/content/bg-shop.jpg" alt="Background" />
        </div>
        <Product className={styles.card} />
      </div>
    </>
  );
};

export default DashboardStudent;
